<template>
  <div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full">
        <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Search</label>
              <vs-input type="text" v-model="filters['search']" class="w-full"  />
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Status</label>
              <v-select v-model="filters['status']" :options="statusList" name="status"/>
            </div>
          </div>
        </vx-card>
        <vx-card title="CREDIT NOTES">
          <template slot="actions">
            <vs-button v-can="'create-edit-credit-note'"  id="create-credit-note-button" @click="onClickCreateCreditNote" class="mr-4" color="primary" type="filled">Create a credit note</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table id="customer-account-limit-request-table" :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff"   :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">
              <template slot="thead">
                <vs-th width="10%" sort-key="change_to">CREDIT NOTE CODE</vs-th>
                <vs-th width="12%" sort-key="change_to">DATE</vs-th>
                <vs-th width="13%" sort-key="created_by">CREATED BY</vs-th>
                <vs-th width="10%" sort-key="note">CREDIT AMOUNT ({{ account_currency }} EXCL VAT/TAX)</vs-th>
                <vs-th width="10%" sort-key="reason_for_change">REMAINING CREDIT AMOUNT ({{ account_currency }} EXCL VAT/TAX)</vs-th>
                <vs-th width="10%" sort-key="status">STATUS</vs-th>
                <vs-th width="10%">ORIGINAL SO CN RAISED AGAINST</vs-th>
                <vs-th width="10%">SO CREDIT USED AGAINST</vs-th>
                <vs-th width="15%" >ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickCustomerCreditNoteUpdate(data[indextr].id)" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].credit_note_code">
                    {{data[indextr].credit_note_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].created_at">
                    {{ __dateTimeFormatterToDate(data[indextr].created_at) }}
                  </vs-td>

                  <vs-td :data="data[indextr].created_by_staff">
                    {{ data[indextr].created_by_staff}}
                  </vs-td>

                  <vs-td :data="data[indextr].credit_amount">
                    {{ Number(data[indextr].credit_amount).toFixed(2) }}
                  </vs-td>

                  <vs-td :data="data[indextr].remaining_credit_amount">
                    {{ Number(data[indextr].remaining_credit_amount).toFixed(2) }}
                  </vs-td>

                  <vs-td :data="data[indextr].status">
                    <vs-chip transparent :color="data[indextr].status === 'Active' ? 'primary' : 'danger'">
                      {{ data[indextr].status }}
                    </vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].product_order_code">
                    <a @click.stop="onCLickViewProductOrder(data[indextr].belongs_to_product_order.id)" class="text-primary cursor-pointer">
                      <vx-tooltip class="ml-2" :text="`View ${data[indextr].belongs_to_product_order.product_order_code}`" position="top">
                        {{ data[indextr].belongs_to_product_order.product_order_code}}
                      </vx-tooltip>
                    </a>
                  </vs-td>

                  <vs-td>
                    <a v-if="tr.credit_note_used_by.length > 0"
                       :key="index_so" v-for="(so, index_so) in tr.credit_note_used_by"
                       @click.stop="onCLickViewProductOrder(so.id)"
                       class="text-primary cursor-pointer">
                      <vx-tooltip class="ml-2" :text="`View ${so.product_order_code}`" position="top">
                        {{ so.product_order_code+', '}}
                      </vx-tooltip>
                    </a>
                    <span v-if="tr.credit_note_used_by.length === 0">N/A</span>
                  </vs-td>


                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip class="ml-2" text="View/Update" position="top">
                        <vs-button @click.stop="onClickCustomerCreditNoteUpdate(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'create-edit-credit-note'" v-if="['Invalid'].includes(data[indextr].status)" class="ml-2" text="Active credit note" position="top">
                        <vs-button @click.stop="onClickStatusChange(data[indextr].id, 'active')"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-check"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'create-edit-credit-note'" v-if="['Active'].includes(data[indextr].status)" class="ml-2" text="Cancel credit note" position="top">
                        <vs-button @click.stop="onClickStatusChange(data[indextr].id, 'invalid')"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'link-credit-note'" class="ml-2" text="Link to customer order" position="top">
                        <vs-button @click.stop="onClickCustomerCreditNoteLinkToOrder(data[indextr].id)"
                                   size="small" color="primary" type="filled" icon-pack="feather" icon="icon-link"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="ml-2" text="Send Credit note" position="left">
                        <vs-button @click.stop="onClickSendCreditNote(data[indextr].credit_note_secret_code,data[indextr].id)" size="small" color="warning" type="border" icon-pack="feather" icon="icon-send"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="ml-2" text="View Credit Note Email Logs" position="top">
                        <vs-button @click.stop="onClickViewCreditNoteEmailLogs(data[indextr].id)"
                                   size="small" color="danger" type="filled" icon-pack="feather" icon="icon-list"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>

    <vs-prompt
      @cancel="status_change_obj={}"
      @accept="changeCreditNoteStatus"
      @close="activePrompt = false"
      :is-valid="isValidReason"
      :title="status_change_obj.status === 'invalid' ? 'Cancel credit note' : 'Active credit note'"
      :accept-text="status_change_obj.status === 'invalid' ? 'Cancel' : 'Active'"
      :color="status_change_obj.status === 'invalid' ? 'danger' : 'primary'"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <span>Status change reason</span>
        <vs-input v-model="status_change_obj.status_reason" class="mt-3 w-full" />
      </div>
    </vs-prompt>

    <create-customer-credit-note-pop-up v-bind:account_currency="account_currency" ref="createCustomerCreditNotePopUp"/>
    <create-credit-note-from-order-pop-up ref="createCreditNoteFromOrderPopUp" v-bind:account_currency="account_currency"/>
    <update-credit-note-from-order-pop-up ref="updateCreditNoteFromOrderPopUp"/>
    <link-customer-credit-note-to-order-pop-up v-bind:account_currency="account_currency" ref="linkCustomerCreditNoteToOrderPopUp"/>
    <credit-note-email-log-pop-up ref="creditNoteEmailLogPopUp"/>

    <vs-prompt
      @cancel="activeSelectOrderPrompt = false"
      @accept="changeStatus"
      @close="activeSelectOrderPrompt = false"
      :title="'Create credit note'"
      :accept-text="'Confirm'"
      :color="'primary'"
      :active.sync="activeSelectOrderPrompt">
      <div class="con-exemple-prompt">
        <span>Select product order</span>
        <v-select
          :clearable="true" name="selected_product_order_id" placeholder=""
          v-model="selected_product_order_id"
          label="product_order_code"
          :options="product_orders"
          :reduce="option => option.id"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
      </div>
    </vs-prompt>

  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  const DropDownRepository = RepositoryFactory.get('drop_down')
  import CreateCustomerCreditNotePopUp from "@/components/popups/customer/credit-note/CreateCustomerCreditNotePopUp";
  import CreateCreditNoteFromOrderPopUp
    from "@/components/popups/customer/product-orders/credit-note/CreateCreditNoteFromOrderPopUp";
  import UpdateCreditNoteFromOrderPopUp
    from "@/components/popups/customer/product-orders/credit-note/UpdateCreditNoteFromOrderPopUp";
  import LinkCustomerCreditNoteToOrderPopUp
    from "@/components/popups/customer/credit-note/LinkCustomerCreditNoteToOrderPopUp";
  import CreditNoteEmailLogPopUp from "@/components/popups/customer/product-orders/credit-note/CreditNoteEmailLogPopUp";
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: 'AllUsersList',
    props: {
      account_currency  : {
        type: String,
        default: '',
      }
    },
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customerId: '',
        status_change_obj: {},
        activePrompt: false,
        activeSelectOrderPrompt: false,
        selected_product_order_id: '',
        product_orders: [],
        statusList: ['Active', 'Invalid', 'Used']
      }
    },
    components: {
      'v-select': vSelect,
      CreateCustomerCreditNotePopUp,
      LinkCustomerCreditNoteToOrderPopUp,
      CreateCreditNoteFromOrderPopUp,
      UpdateCreditNoteFromOrderPopUp,
      CreditNoteEmailLogPopUp,
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.customerId = this.$route.params.id
      if (this.$route.query.open) {
        await this.onClickCustomerCreditNoteUpdate(this.$route.query.open)
      }
    },
    methods: {
      async refreshData () {
        await this.loadStaff()
      },

      async loadStaff() {
        await this.$vs.loading({
          container: '#customer-account-limit-request-table',
          scale: 0.45
        })
        const {data} = await CustomerRepository.getCustomerCreditNoteList(this.customerId, this.page, this.filterQuery, 10, this.sort)
        this.staff =  data.data
        this.meta = data.meta
        this.$vs.loading.close('#customer-account-limit-request-table > .con-vs-loading')
      },

      async onClickCreateCreditNote () {
        await this.fetchProductOrders()
        this.activeSelectOrderPrompt = true
      },
      async onClickCustomerCreditNoteUpdate (id) {
        await this.$refs.updateCreditNoteFromOrderPopUp.openPopup(id, this.customerId)
      },
      async onClickCustomerCreditNoteLinkToOrder (id) {
        await this.$refs.linkCustomerCreditNoteToOrderPopUp.openPopup(id, this.customerId)
      },
      async onCLickViewProductOrder(id) {
        await this.$router.push({path: `/pages/product-orders/${id}`})
      },
      async onClickViewCreditNoteEmailLogs(id) {
        await this.$refs.creditNoteEmailLogPopUp.openPopup(id)
      },
      onClickSendCreditNote(secret_code,id){
        let routeData = this.$router.resolve({name:'credit-note-print-view', params:{secret_code: secret_code, id: id}})
        window.open(routeData.href,'_blank');
      },
      async fetchProductOrders() {
        await this.$vs.loading({
          container: '#create-credit-note-button',
          scale: 0.45
        })
        try {
          const {data} = (await DropDownRepository.getProductOrderList(this.customerId)).data
          this.product_orders = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-credit-note-button > .con-vs-loading')
      },
      filterQueryUpdate (){
        this.page = 1
        this.loadStaff()
      },

      handleChangePage(page) {
        this.page=page;
        this.loadStaff()
      },
      projectBriefColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning';
          case 2:
            return 'primary';
          case 3:
            return 'danger';
        }
      },
      onClickStatusChange(id, status) {
        this.status_change_obj.status = status
        this.status_change_obj.id = id
        this.activePrompt =  true
      },
      async changeCreditNoteStatus() {
        this.$vs.loading()
        try {
          const {data} = await CustomerRepository.statusChangeCreditNote(this.status_change_obj.id, {status_reason: this.status_change_obj.status_reason} , this.status_change_obj.status)
          this.status_change_obj.status_reason = null
          await this.loadStaff()
          this.showSuccessMessage('Status changed successfully!')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async changeStatus() {
        this.activeSelectOrderPrompt = false
        await this.$refs.createCreditNoteFromOrderPopUp.openPopup(this.selected_product_order_id, this.customerId)
      }
    },
    watch : {
      page(){
        this.loadStaff()
      }
    },
    computed: {
      isValidReason() {
        if (!this.status_change_obj.status_reason){
          return false
        }
        return this.status_change_obj.status_reason.length > 2;
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
